module.exports = __webpack_public_path__ + "d19128bef61ce362d45c501812cef7d1.svg";